import Dispatcher from '../dispatcher';
import { VehicleDetailsLightBoxActions } from '../constants/vehicle_details_light_box/vehicle_details_light_box_actions';

function showAction() {
    Dispatcher.handleVehicleDetailsLightboxAction({
        type: VehicleDetailsLightBoxActions.SHOW,
    });
}

function hideAction() {
    Dispatcher.handleVehicleDetailsLightboxAction({
        type: VehicleDetailsLightBoxActions.HIDE
    });
}

function expandAction() {
    Dispatcher.handleVehicleDetailsLightboxAction({
        type: VehicleDetailsLightBoxActions.EXPAND
    });
}

export {
    showAction,
    hideAction,
    expandAction,
};
